// extracted by mini-css-extract-plugin
export default {"toast":"YexH_pRPP2OYLDvomz5w"};